



























import Vue from "vue";
import moment from "moment";

export default Vue.extend({
  name: "Item",
  props: {
    item: Object
  },
  data: () => ({
    startDate: "",
    isOver: false,
    beforeAuction: false,
  }),
  methods: {
    goDetail(id: any) {

      this.$router.push({ name: 'Detail', params: { id: id} });
    }
  },
  created() {
    this.startDate = moment(this.item.startDate).format('YY[/]MM[/]DD HH:mm');
    // 경매 시작 전/종료 후 확인
    const now = new Date()
    if (new Date(this.item.endDate) < now) {
      this.isOver = true;
    } else if (new Date(this.item.startDate) > now) {
      this.beforeAuction = true;
    }
    if (Number(this.item.status) !== 0) {
      this.isOver = true;
    }
    // console.log(this.isOver)
    // console.log(this.beforeAuction)
  }
});
